import manager from "./manager"

function getStores (preStores) {
  const keys = Object.keys(preStores)
  const stores = {}
  keys.forEach(key => {
    if (typeof preStores[key] === "function") {
      stores[key] = new preStores[key]()
    } else {
      stores[key] = preStores[key]
    }
  })
  return stores
}

export default getStores({manager})



// WEBPACK FOOTER //
// ./src/app/components/normal/BasicModal/UploadModal/stores/index.js